import { FindUserModalComponent } from '@common/auth/find-user-modal/find-user-modal.component';
import {
    DatatableFilter,
    FilterControlType
} from '@common/datatable/datatable-filters/search-input-with-filters/filter-config/datatable-filter';
import {
    CreatedAtFilter,
    UpdatedAtFilter
} from '@common/datatable/datatable-filters/search-input-with-filters/filter-config/timestamp-filter';

export const LINK_GROUP_INDEX_FILTERS: DatatableFilter[] = [
    new DatatableFilter({
        type: FilterControlType.Select,
        key: 'active',
        label: 'status',
        defaultValue: false,
        description: 'Whether group is public or not',
        options: [
            {key: 'Disabled', value: false},
            {key: 'Active', value: true},
        ],
    }),
    new DatatableFilter({
        type: FilterControlType.Select,
        key: 'rotator',
        label: 'rotator',
        defaultValue: false,
        description: 'Whether group is used as link rotator',
        options: [
            {key: 'Yes', value: true},
            {key: 'No', value: false},
        ],
    }),
    new CreatedAtFilter({
        description: 'Date link group was created',
    }),
    new UpdatedAtFilter({
        description: 'Date link group was last updated',
    }),
    new DatatableFilter({
        type: FilterControlType.SelectModel,
        key: 'user_id',
        label: 'User',
        description: 'User group was created by',
        component: FindUserModalComponent,
    }),
];
